const buttonClass = 'btn-sm btn-light'

const zhCnDatatableLanguage = {
  processing: '处理中...',
  search: '搜索:',
  lengthMenu: '每页显示 _MENU_ 条',
  info: '显示第 _START_ 到 _END_ 条，共 _TOTAL_ 条',
  infoEmpty: '暂无数据',
  infoFiltered: '(从 _MAX_ 条记录中筛选)',
  infoPostFix: '',
  loadingRecords: '加载中...',
  zeroRecords: '没有找到匹配的记录',
  emptyTable: '表中暂无数据',
  paginate: {
    first: '首页',
    previous: '上一页',
    next: '下一页',
    last: '末页'
  },
  aria: {
    sortAscending: ': 激活以升序排序',
    sortDescending: ': 激活以降序排序'
  },
  buttons: {
    copy: '复制',
    csv: '导出 CSV',
    print: '打印'
  },
  select: {
    rows: {
      _: '已选择 %d 行',
      0: '',
      1: '已选择 1 行'
    }
  }
}

const defaultDatatableLanguage = document.documentElement.lang.toLowerCase().startsWith('zh')
  ? zhCnDatatableLanguage
  : undefined

const defaultDatatableOptions = {
  serverSide: true,
  processing: true,
  stateSave: true,
  lengthMenu: [10, 100, 500],
  language: defaultDatatableLanguage,
  dom: '<"d-flex justify-content-between"lBf>rt<"d-flex justify-content-between"ip>',
  buttons: [
    [
      { extend: 'copy', className: buttonClass, text: '<i data-feather="copy"></i>' },
      { extend: 'csv', className: buttonClass, text: '<i data-feather="file-text"></i>' }
    ]
  ],
  responsive: true,
  stateSaveCallback: function (settings, data) {
    localStorage.setItem('DataTables_' + settings.sInstance, JSON.stringify(data))
  },
  stateLoadCallback: function (settings) {
    const states = JSON.parse(localStorage.getItem('DataTables_' + settings.sInstance))

    if (states === null) { return null }

    // clear the search
    states.search.search = ''

    return states
  }
}

export { defaultDatatableOptions }
